var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { GoalPlannerTemplate } from '@/models/GoalPlannerTemplate';
import { GoalPlannerTimeslot } from '@/models/GoalPlannerTimeslot';
import ErrorHandler from '@/support/ErrorHandler';
import { Component, Prop, Vue } from 'vue-property-decorator';
import AColorPicker from '@/components/AColorPicker/AColorPicker.vue';
let CreateOrEditGoalPlannerTimeslotDialog = class CreateOrEditGoalPlannerTimeslotDialog extends Vue {
    constructor() {
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        this.internalTimeslot = null;
        this.days = [
            { text: 'Ma.', value: 'monday' },
            { text: 'Di.', value: 'tuesday' },
            { text: 'Wo.', value: 'wednesday' },
            { text: 'Do.', value: 'thursday' },
            { text: 'Vr.', value: 'friday' },
        ];
        this.selectedDays = [];
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.initializeTimeslot();
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    onSubmit() {
        if (!this.internalTimeslot) {
            return;
        }
        const payload = {
            template_id: this.template.id,
            title: this.internalTimeslot.title,
            day: !this.isEditing ? this.selectedDays : this.internalTimeslot.day,
            starts_at: this.internalTimeslot.starts_at,
            ends_at: this.internalTimeslot.ends_at,
            color: this.internalTimeslot.color,
        };
        if (this.isEditing) {
            this.onUpdateTimeslot(payload);
        }
        else {
            this.onCreateTimeslot(payload);
        }
    }
    // #endregion
    // #region Class methods
    close() {
        this.$emit('close');
        this.clear();
    }
    clear() {
        this.internalTimeslot = null;
    }
    // #endregion
    // #region Async methods (api calls only)
    async onDeleteTimeslot() {
        if (!this.internalTimeslot || !this.existingTimeslot) {
            return;
        }
        try {
            await this.internalTimeslot.delete();
            this.$emit('goalPlannerTimeslotDeleted');
            this.clear();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async onUpdateTimeslot(payload) {
        if (!this.internalTimeslot || !this.existingTimeslot || !this.isValid) {
            return;
        }
        try {
            await this.internalTimeslot.update(payload);
            this.$emit('goalPlannerTimeslotUpdated');
            this.clear();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async onCreateTimeslot(payload) {
        if (!this.internalTimeslot || !this.newTimeslot || !this.isValid) {
            return;
        }
        try {
            await new GoalPlannerTimeslot().create(payload);
            this.$emit('goalPlannerTimeslotCreated');
            this.clear();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async initializeTimeslot() {
        if (this.existingTimeslot) {
            this.internalTimeslot = new GoalPlannerTimeslot(this.existingTimeslot);
        }
        else {
            this.internalTimeslot = new GoalPlannerTimeslot(this.newTimeslot);
        }
        this.selectedDays = this.internalTimeslot.day ? [this.internalTimeslot.day] : [];
    }
    // #endregion
    // #region Getters & Setters
    get isWeekTemplate() {
        return this.template && this.template.getIsWeekTemplate();
    }
    get isValid() {
        return (this.internalTimeslot !== null &&
            !!this.internalTimeslot.title &&
            this.internalTimeslot.title.trim() !== '' &&
            !!this.internalTimeslot.starts_at &&
            !!this.internalTimeslot.ends_at);
    }
    get isEditing() {
        return !!this.existingTimeslot;
    }
    get title() {
        return this.isEditing
            ? this.$tc('Edit period planner timeslot')
            : this.$tc('Add period planner timeslot');
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof GoalPlannerTemplate !== "undefined" && GoalPlannerTemplate) === "function" ? _a : Object)
], CreateOrEditGoalPlannerTimeslotDialog.prototype, "template", void 0);
__decorate([
    Prop({ required: false }),
    __metadata("design:type", typeof (_b = typeof GoalPlannerTimeslot !== "undefined" && GoalPlannerTimeslot) === "function" ? _b : Object)
], CreateOrEditGoalPlannerTimeslotDialog.prototype, "newTimeslot", void 0);
__decorate([
    Prop({ required: false }),
    __metadata("design:type", typeof (_c = typeof GoalPlannerTimeslot !== "undefined" && GoalPlannerTimeslot) === "function" ? _c : Object)
], CreateOrEditGoalPlannerTimeslotDialog.prototype, "existingTimeslot", void 0);
CreateOrEditGoalPlannerTimeslotDialog = __decorate([
    Component({
        components: {
            AColorPicker,
        },
    })
], CreateOrEditGoalPlannerTimeslotDialog);
export default CreateOrEditGoalPlannerTimeslotDialog;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
